"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentManifestRelated = void 0;
/**
 * A collection of documents compiled for a purpose together with metadata that applies to the collection.
 */
var DocumentManifestRelated = /** @class */ (function () {
    function DocumentManifestRelated() {
    }
    return DocumentManifestRelated;
}());
exports.DocumentManifestRelated = DocumentManifestRelated;
